export default "__VITE_ASSET__BG3s7bq$__"